import ImageOne from '../images/picinterior.jpg';
import ImageTwo from '../images/pichome.jpg';

export const InfoData = {
    heading:'דירות חדשות בשיווק בלעדי',
    paragraphOne: 'דירות גן 5 חדרים' ,
    paragraphTwo: 'דירות 3 חדרים ברמה גבוה',
    buttonLabel: 'עמוד הבית',
    image: ImageOne ,
    reverse: false,
    delay: 100

};

export const InfoDataTwo ={
    heading: 'Modern Desings',
    paragraphOne: 'Lorem input new homes',
    paragraphTwo: 'the to of gole id',
    buttonLabel: 'view Homes',
    image: ImageTwo,
    reverse: true,
    delay: 300
};